import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import {IMedicationForTemplate} from "../../../../../utils/interfaces";
import classes from "./ViewMedicationTemplateTimeline.module.scss";

export const ViewMedicationTemplateTimeline = ({
  medications
}: {
  medications: IMedicationForTemplate[];
}) => {
  const hasSetAfterSurgeryDate = medications?.some(medication => !!medication.startDayAfterSurgery);

  return (
    <div className={classes.treatmentTimelineContainer}>
      <h2>Treatment Timeline</h2>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Dosage</TableCell>
              <TableCell align="left">Times</TableCell>
              <TableCell align="left">Duration</TableCell>
              {hasSetAfterSurgeryDate ? <TableCell align="left">Start after surgery</TableCell> : null}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {medications &&
              medications.map(
                (medication, index) => {
                  return (
                    <TableRow className={classes.tableRow} key={medication.id}>
                      <TableCell align="left">{medication.name}</TableCell>
                      <TableCell align="left">{medication.dosageValue} {medication.dosageUnit}</TableCell>
                      <TableCell align="left">
                        <div style={{display: 'flex', flexDirection: 'row', gap: 8}}>
                          {medication.times.map((time, index) => {
                            const splittedTime = time.split(':');
                            const formattedTime = `${splittedTime[0]}:${splittedTime[1]}`;

                            return (
                              <Chip size="small" key={index} label={formattedTime} variant="outlined" />
                            )
                          })}
                        </div>
                      </TableCell>
                      <TableCell align="left">{medication.duration} day{medication.duration > 1 ? 's' : ''}</TableCell>
                      {hasSetAfterSurgeryDate ? <TableCell align="left">{medication.startDayAfterSurgery} {medication.startDayAfterSurgery ? `day${medication.startDayAfterSurgery > 1 ? 's' : ''}` : ''}</TableCell> : null}
                    </TableRow>
                  );
                }
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
